"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaStepperButton = _interopRequireDefault(require("./AaStepperButton.component"));

var _AaStepper = require("./AaStepper.model");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _uiUtils = require("@airasia/ui-utils");

// @floe
var AaStepper = function AaStepper(props) {
  var _useState = (0, _react.useState)(props),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      stepperProps = _useState2[0],
      setStepperProps = _useState2[1];

  (0, _react.useEffect)(function () {
    setStepperProps(props);
  });
  var belowMin = stepperProps.controls.min != null && stepperProps.data <= stepperProps.controls.min;
  var aboveMax = stepperProps.controls.max != null && stepperProps.data >= stepperProps.controls.max;
  var disableDecrement = belowMin || stepperProps.controls.disableDecrement;
  var disableIncrement = aboveMax || stepperProps.controls.disableIncrement; // const iconProps = {
  //     color: defaultTokens.colorIconSecondary,
  //     size: 'small',
  // };

  var numberDisplayed = stepperProps.data;

  if (belowMin) {
    numberDisplayed = stepperProps.controls.min;
  }

  if (aboveMax) {
    numberDisplayed = stepperProps.controls.max;
  }

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: defaultStyles.stepperContainer
  }, /*#__PURE__*/_react["default"].createElement(_AaStepperButton["default"], {
    onPress: stepperProps.controls.onDecrement,
    type: "minus",
    disabled: disableDecrement,
    accessibilityProps: stepperProps.controls.accessibilityProps ? stepperProps.controls.accessibilityProps.removeAccessibilityProps : null
  }), stepperProps.controls.showNumber && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: defaultStyles.number
  }, numberDisplayed), /*#__PURE__*/_react["default"].createElement(_AaStepperButton["default"], {
    onPress: stepperProps.controls.onIncrement,
    type: "add",
    disabled: disableIncrement,
    accessibilityProps: stepperProps.controls.accessibilityProps ? stepperProps.controls.accessibilityProps.addAccessibilityProps : null
  }));
};

var defaultStyles = _StyleSheet["default"].create({
  stepperContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  number: {
    marginHorizontal: 10,
    color: "#212124",
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    fontSize: 20,
    width: 30,
    textAlign: 'center',
    web: {
      fontWeight: '100',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  }
});

var _default = AaStepper;
exports["default"] = _default;